<template>
    <div class="history">
        <quotations-filter :is-load-xml="condition.idLoadXml"
                           :is-mobile="condition.isMobile"
                              :is-load-data="condition.isLoadTable"
                              :quotations="quotations"
                              :quotation-products="quotationProducts"
                              @init-quotations-list="initList(1)"
                              ref="filter"></quotations-filter>
        <quotations-list ref="quotationsList"
                     @init-quotations-list="initList"
                     @filter-status-wrap="filterStatusWrap()"
                     @change-filter-params="changeFilterParams"
                     :prolong-statuses="prolongClientStatuses"
                     :is-load-data="condition.isLoadTable"
                     :is-mobile="condition.isMobile"
                     :quotations="quotations"></quotations-list>
        <div style="text-align: center">
            <pagination v-show="total > 0" :total="total"
                        :page.sync="listQuery.page"
                        :limit.sync="listQuery.limit" @pagination="initList()" />
        </div>
    </div>
</template>


<script>
  import Vue from "vue";
  import { orderMixin } from '@/mixin'
  import displaySettings from "@/mixin/displaySettings";
  import Pagination from '@/components/Pagination';
  import { fetchQuotationRequests, getQuotationTypes  } from "@/api/quotation";
  import { default as quotationsList } from "@/views/quotations/quotationsList.vue";
  import { default as quotationsFilter } from "@/views/quotations/quotationFilter";

  const FileDownload = require('js-file-download');

  export default {
    mixins: [orderMixin, displaySettings],
    components: {
      quotationsList,
      quotationsFilter,
      Pagination,
    },
    data: function () {
      return {
        quotations: [],
        quotationProducts: [],
        total: 1,
        mobileWith: 992,
        condition: {
          isLoadTable: true,
          isLoadXml: false,
          isMobile: false,
        },
        listQuery: {
          page: 1,
          limit: 20,
        }
      }
    },
    created: function() {
      window.addEventListener("resize", this.checkWindowResize);
      this.checkIsMobile();
    },
    mounted: function() {
      this.initList();
      this.getQuotationProducts();
    },
    computed:{
      prolongClientStatuses: function () {
        return this.$store.getters.PROLONG_STATUSES;
      },
    },
    methods: {
      checkIsMobile: function() {
        return this.condition.isMobile = window.innerWidth < this.mobileWith;
      },
      checkWindowResize: function() {
        this.checkIsMobile()
      },
      filterStatusWrap: function() {
        this.$refs.filter.filterStatusWrap(true);
      },
      changeFilterParams: function(dates, page) {
        this.$refs.filter.dateFilter = dates;
        this.listQuery.page = 1;
      },
      getQuery: function () {
        return {...this.$refs.filter.listQuery, ...this.$refs.quotationsList.listQuery, ...this.listQuery};
      },
      initList: async function (filterButtonEvent) {
        if (filterButtonEvent === 1) {
          this.listQuery.page = 1;
        }
        let response;
        this.quotations = [];
        this.condition.isLoadTable = true;

        response = await fetchQuotationRequests(this.getQuery());
        this.quotations = response.data.data?.items;
        this.total = response.data.data?.total;
        this.condition.isLoadTable = false;
      },
      getQuotationProducts: async function() {
        let response;
        response = await getQuotationTypes();
        this.quotationProducts = response.data;
      }
    },
    destroyed() {
      window.removeEventListener("resize", this.checkWindowResize);
    },
  }
</script>
